import React, { useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Admin.css';

export const Admin = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('role');
    localStorage.removeItem('token'); // optional
    window.dispatchEvent(new Event('storage'));
    navigate('/login');
  };
  const imageRef = useRef(null);

useEffect(() => {
  const imageEl = imageRef.current;
  if (!imageEl) return;

  let scale = 1;
  let direction = 1;

  const handleMouseMove = (e) => {
    const { left, top, width, height } = imageEl.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;

    const rotateX = ((y / height) - 0.5) * 75; // adjust intensity if needed
    const rotateY = ((x / width) - 0.5) * 75;

    imageEl.style.transform = `scale(${scale}) rotateX(${-rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const zoomInterval = setInterval(() => {
    if (scale >= 1.08) direction = -1;
    if (scale <= 1.0) direction = 1;
    scale += direction * 0.005;

    // Optional: apply scale only if not interacting
    imageEl.style.transform = `scale(${scale})`;
  }, 40);

  window.addEventListener('mousemove', handleMouseMove);

  return () => {
    window.removeEventListener('mousemove', handleMouseMove);
    clearInterval(zoomInterval);
  };
}, []);






 return (
  <div className="admin-container">
    {/* Sidebar */}
    <div className="admin-sidebar">
      <h2 className="sidebar-title">🛠️ Admin Panel</h2>
      <div className="admin-box-links">
        <Link to="/jobpost" className="admin-box">📢 Post Job</Link>
        <Link to="/GalleryEdit" className="admin-box">🖼️ Edit Gallery</Link>
        <Link to="/adminview" className="admin-box">👥 JOB Applications</Link>
        <Link to="/Adminslider" className="admin-box">📨 Add Slider</Link>
        <Link to="/Adminblog" className="admin-box">📨 Admin Blog</Link>
        <Link to="/AdminTest" className="admin-box">📨 Admin Testimonials</Link>
        <Link to="/DownloadSubmission" className="admin-box">📨course submission data</Link>
        <div onClick={handleLogout} className="admin-box logout-box" style={{ cursor: 'pointer' }}>
          🚪 Logout
        </div>
      </div>
    </div>

    {/* Main Content */}
    <div className="admin-content">
      <h1>Welcome, Admin 👋</h1>
      <img
        ref={imageRef}
        src="/assets/img/oo.jpg"
        alt="Admin Overview"
        className="admin-dashboard-image"
      />
    </div>
  </div>
);

};

